/* ============================================================= */
/*  ll-model-collateral-edit.component.ts                        */
/* ============================================================= */

import {
  Component,
  ViewChild,
  AfterViewInit,
  AfterViewChecked,
  ElementRef,
  OnDestroy,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';
import { LlModelsService } from '../ll-models.service';
import { LlRolesService } from '../ll-roles.service';
import { LlUtilityService } from '../ll-utility.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxPopoverComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxpopover";

interface Choice {
  choice: string;
}
interface FRONTENDARRAY {
  rowIdx: number;
  type: string;
  sysId: number;
  targetElement: string;
  targetElementLabel: string;
  targetElementValue: string;
  cascaidToAllClasses?: 'yes' | 'no';
  cascaidToAllpayers?: 'yes' | 'no';
}
interface PayerRecord {
  RECORDID: string;
  NAME: string;
  SYSID: string;
  FINANCIALCLASSNAME: string;
  PAYERELIGIBLE: 'Yes' | 'No';
  LIMIT_BILLED_AGECAPDAYS: string;
  LIMIT_BILLEDADVANCE_PCT: number;
  LIMIT_UNBILLEDADVANCE_PCT: number;
  DYNAMICENVYESNO: 'Yes' | 'No';
  PRORATEUNBILLEDYESNO: 'Yes' | 'No';
  LIMIT_ENV_OVERRIDE_PCT: number;
  LIMIT_ENVCALCBUCKET_DAYS: string;
  LIMIT_ENV_PCT_PAYERID_SURROGATE: string;
}

@Component({
  selector: 'll-model-collateral-edit',
  templateUrl: './ll-model-collateral-edit.component.html',
  styleUrls: ['../cssMain.css']
})
export class LlModelCollateralEditComponent
  implements AfterViewInit, AfterViewChecked, OnDestroy {

  @ViewChild('mainDiv_ll_model_collateral_edit') mainDiv!: ElementRef<HTMLElement>;
  @ViewChild('datagrid_ll_model_collateral_edit') datagrid!: jqxGridComponent;
  @ViewChild('popover_dialog') popover_dialog!: jqxPopoverComponent;
  @ViewChild('popover_userEntryMsg') popover_userEntryMsg!: jqxPopoverComponent;

  /* ----------------------------------------------------------- */
  bundle = {
    yesNoChoices: [] as Choice[],
    periodChoices: [] as Choice[],
    FRONTENDARRAY: [] as FRONTENDARRAY[],
    gridX: 0,
    gridY: 50,
    gridW: 0,
    gridH: 0,
    records: [] as PayerRecord[],
    columns: [] as any[],
    horzTabs: [],
    showObj: false,
    saved: true,
    showPayerEdit: false,
    headerLable: "Collateral Settings",
    fileLabel: '',
    activeCODE: 'model',
    headerDescription: '',
    userMessage: '',
    userEntryMessage: '',
    targetElementLabel: '',
    targetElementValue: '',
  };

  openDropdownIndex = -1;
  private gridInitialized = false;

  constructor(
    private llModelsService: LlModelsService,
    private LlRolesService: LlRolesService,
    private LlUtilityService: LlUtilityService,
    private cd: ChangeDetectorRef
  ) { }

  /* ----------------------------------------------------------- */
  ngAfterViewInit(): void {
    this.setVars();
  }

  ngAfterViewChecked(): void {
    if (this.bundle.showPayerEdit && this.datagrid && !this.gridInitialized) {
      this.gridInitialized = true;
      setTimeout(() => this.paintGrid(), 0);
    }
  }

  ngOnDestroy(): void {
    this.gridInitialized = false;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.calculateGridSize();
    if (this.datagrid) {
      this.datagrid.width(this.bundle.gridW);
      this.datagrid.height(this.bundle.gridH);
    }
  }

  /* ============================================================= */
  private setVars(): void {

    let activeModel: any = this.llModelsService.getActiveCompanyLoanModel();


    //console.log(activeModel);
    //console.log("activeModel.LENDERCLASSBBCYESNO:" + activeModel.LENDERCLASSBBCYESNO);

    this.bundle.fileLabel = this.bundle.headerLable;
    this.bundle.headerDescription = "Click on grid-cell to change its value.  Hit 'Enter' key to save change."

    this.bundle.horzTabs.push({ LABEL: "Model", CODE: "model" });

    if (activeModel.LENDERCLASSBBCYESNO === 'Yes') {
      this.bundle.horzTabs.push({ LABEL: "Lender Classes", CODE: "classes" });
    } else {
      this.bundle.horzTabs.push({ LABEL: "Client Classes", CODE: "classes" });
    }

    this.bundle.horzTabs.push({ LABEL: "Payers", CODE: "payers" });

    this.bundle.activeCODE = this.bundle.horzTabs[0].CODE;

    setTimeout(() => {
      this.calculateGridSize();
      this.initializeChoices();
      this.getData();
    }, 0);
  }

  private calculateGridSize(): void {
    const container = this.mainDiv.nativeElement.parentElement?.parentElement;
    if (container) {
      const margin = 20;
      this.bundle.gridW = container.clientWidth - margin;
      this.bundle.gridH = container.clientHeight - this.bundle.gridY - 40;
      this.bundle.gridX = (container.clientWidth - this.bundle.gridW) / 2;
    }
  }

  private initializeChoices(): void {
    this.bundle.yesNoChoices = [{ choice: 'Yes' }, { choice: 'No' }];
    this.bundle.periodChoices = [
      { choice: '30' }, { choice: '60' }, { choice: '90' },
      { choice: '120' }, { choice: '150' }, { choice: '180' }
    ];
  }

  /* ============================================================= */
  private getData(): void {
    const callback = (records: any[]) => {
      this.bundle.records = records;
      this.bundle.showPayerEdit = true;
      this.cd.detectChanges();

      if (this.bundle.activeCODE.toLowerCase() != 'model') {
        setTimeout(() =>
          this.paintGrid(), 0);
      };
    };

    //console.log("this.bundle.activeCODE: " + this.bundle.activeCODE)

    if (this.bundle.activeCODE.toLowerCase() === 'model' || this.bundle.activeCODE.toLowerCase() === 'classes') {
      this.bundle.userMessage = "Click on grid-cell to change its value.  Key 'Enter' key to save change. You may be prompted to cascaided applicable changes."
    } else if (this.bundle.activeCODE.toLowerCase() === 'payers') {
      this.bundle.userMessage = "Click on grid-cell to change its value.  Key 'Enter' key to save change."
    }

    this.llModelsService.NG_LL_model_AR_configEdit_get(callback, this.bundle.activeCODE);

  }

  /* ============================================================= */
  private paintGrid(): void {
    if (!this.datagrid) {
      console.warn('jqxGrid not ready – will retry in 100 ms');
      setTimeout(() => this.paintGrid(), 100);
      return;
    }
    
    const contactRoleId = this.LlRolesService.getActiveContactRoleId();
    this.bundle.columns = [];

    if (this.bundle.activeCODE.toLowerCase() != 'model') {
      this.bundle.columns.push({ text: 'Name', datafield: 'NAME', width: 200, editable: false });
    }

    if (this.bundle.activeCODE.toLowerCase() === 'payers') {
      this.bundle.columns.push({ text: 'Class', datafield: 'FINANCIALCLASSNAME', width: 150, editable: false });
    }

    if (this.bundle.activeCODE.toLowerCase() != 'model') {
      this.bundle.columns.push({
        text: 'Eligible', datafield: 'PAYERELIGIBLEYN', width: 80, columntype: 'dropdownlist',
        createeditor: (_row: number, _value: any, editor: any) => {
          editor.jqxDropDownList({
            source: this.bundle.yesNoChoices.map(c => c.choice),
            displayMember: 'choice',
            valueMember: 'choice'
          });
        }
      });
    }
    this.bundle.columns.push({
      text: 'Age Cap', datafield: 'LIMIT_BILLED_AGECAPDAYS', width: 90, columntype: 'dropdownlist',
      createeditor: (_row: number, _value: any, editor: any) => {
        editor.jqxDropDownList({ source: this.bundle.periodChoices.map(c => c.choice) });
      }
    });

    this.bundle.columns.push({ text: 'Adv% Billed', datafield: 'LIMIT_BILLEDADVANCE_PCT', width: 90, columntype: 'numberinput', headerTextWrapping: true });
    this.bundle.columns.push({ text: 'Adv% Unbilled', datafield: 'LIMIT_UNBILLEDADVANCE_PCT', width: 90, columntype: 'numberinput', headerTextWrapping: true });

    if (this.bundle.activeCODE.toLowerCase() == 'model') {

      this.bundle.columns.push({
        text: 'Current Period', datafield: 'LIMIT_CURRENTINCLUDEDYESNO', width: 100, columntype: 'dropdownlist',
        createeditor: (_row: number, _value: any, editor: any) => {
          editor.jqxDropDownList({
            source: this.bundle.yesNoChoices.map(c => c.choice),
            displayMember: 'choice',
            valueMember: 'choice'
          });
        }
      });

      this.bundle.columns.push({
        text: 'Prorate Unbilled', datafield: 'LIMIT_CURRENTEARNEDYESNO', width: 100, columntype: 'dropdownlist',
        createeditor: (_row: number, _value: any, editor: any) => {
          editor.jqxDropDownList({
            source: this.bundle.yesNoChoices.map(c => c.choice),
            displayMember: 'choice',
            valueMember: 'choice'
          });
        }
      });

     
    }

    this.bundle.columns.push({
      text: 'Cross Age', datafield: 'LIMIT_CROSSAGE_YESNO', width: 100, columntype: 'dropdownlist',
      createeditor: (_row: number, _value: any, editor: any) => {
        editor.jqxDropDownList({
          source: this.bundle.yesNoChoices.map(c => c.choice),
          displayMember: 'choice',
          valueMember: 'choice'
        });
      }
    });

    this.bundle.columns.push({
      text: 'Cross Age Days', datafield: 'LIMIT_CROSSAGE_DAYS', width: 90, columntype: 'dropdownlist',
      createeditor: (_row: number, _value: any, editor: any) => {
        editor.jqxDropDownList({ source: this.bundle.periodChoices.map(c => c.choice) });
      }
    });

    this.bundle.columns.push({ text: 'Cross Age %', datafield: 'LIMIT_CROSSAGE_PCT', width: 120, columntype: 'numberinput' });


    this.bundle.columns.push({
      text: 'Dync ENV', datafield: 'LIMIT_ENV_DYNAMICYESNO', width: 100, columntype: 'dropdownlist',
      createeditor: (_row: number, _value: any, editor: any) => {
        editor.jqxDropDownList({
          source: this.bundle.yesNoChoices.map(c => c.choice),
          displayMember: 'choice',
          valueMember: 'choice'
        });
      }
    });

    this.bundle.columns.push({
      text: 'ENV Bucket', datafield: 'LIMIT_ENV_CALCPERIOD_DAYS', width: 90, columntype: 'dropdownlist',
      createeditor: (_row: number, _value: any, editor: any) => {
        editor.jqxDropDownList({ source: this.bundle.periodChoices.map(c => c.choice) });
      }
    });

    


    this.bundle.columns.push({ text: 'ENV Override %', datafield: 'LIMIT_ENV_OVERRIDE_PCT', width: 120, columntype: 'numberinput' });

    if (this.bundle.activeCODE.toLowerCase() === 'payers') {
      this.bundle.columns.push({ text: 'ENV % Surrogate', datafield: 'LIMIT_ENV_PAYERID_SURROGATE', width: 150, editable: false });
    }

    if (this.bundle.activeCODE.toLowerCase() == 'model') {
      this.bundle.columns.push({
        text: 'UnPstd Cap', datafield: 'LIMIT_UNPOSTED_AGECAPDAYS', width: 90, columntype: 'dropdownlist',
        createeditor: (_row: number, _value: any, editor: any) => {
          editor.jqxDropDownList({ source: this.bundle.periodChoices.map(c => c.choice) });
        }
      });

      this.bundle.columns.push({
        text: 'UnPstd Inel Payrs', datafield: 'LIMIT_UNPOSTED_INELIGIBLEPAYERSYESNO', width: 150, columntype: 'dropdownlist',
        createeditor: (_row: number, _value: any, editor: any) => {
          editor.jqxDropDownList({
            source: this.bundle.yesNoChoices.map(c => c.choice),
            displayMember: 'choice',
            valueMember: 'choice'
          });
        }
      });
    }

    const datafields = this.bundle.columns.map(col => ({
      name: col.datafield,
      type: col.columntype === 'numberinput' || col.datafield.includes('_pct') || col.datafield.includes('Advance') ? 'number' : 'string'
    }));

    setTimeout(() => { 
    const source = { localdata: this.bundle.records, datatype: 'array', datafields };
    const dataAdapter = new jqx.dataAdapter(source);

    this.datagrid.source(dataAdapter);
    this.datagrid.columns(this.bundle.columns);
    this.datagrid.width(this.bundle.gridW);
    this.datagrid.height(this.bundle.gridH);
    this.datagrid.updatebounddata();
    }, 0);

    setTimeout(() => {
      ///this.bundle.showPayerEdit = true;
      this.bundle.showObj = true;
    }, 0);
  }

  /* ============================================================= */
  /*  CELL VALUE CHANGED                                           */
  /* ============================================================= */

  onCellbeginedit(event: any): void {
    this.bundle.saved = false;
  }

  onCellvaluechanged(event: any): void {
    const rowIdx = event.args.rowindex;
    const field = event.args.datafield;
    const newVal = event.args.value;

    this.bundle.records[rowIdx][field] = newVal;

    for (let i = 0; i < this.bundle.columns.length; i++) {
      if (this.bundle.columns[i].datafield === field) {
        this.bundle.FRONTENDARRAY = [{
          rowIdx: event.args.rowindex,
          type: this.bundle.activeCODE,
          sysId: Number(this.bundle.records[rowIdx].SYSID),
          targetElement: field,
          targetElementLabel: this.bundle.columns[i].text,
          targetElementValue: this.bundle.records[rowIdx][field]
        }];

        this.bundle.targetElementLabel = this.bundle.columns[i].text
        this.bundle.targetElementValue = this.bundle.records[rowIdx][field]


        //if (field === "DYNAMICENVYESNO" && this.bundle.records[rowIdx].DYNAMICENVYESNO.toLocaleLowerCase() == 'no' && this.bundle.records[rowIdx].LIMIT_ENV_OVERRIDE_PCT === 0) {
        //  this.bundle.userEntryMessage = "ENV Override %"

        //}

        if (this.bundle.activeCODE === 'payers') {
          this.save();
        } else if (this.bundle.activeCODE === 'classes') {
          this.openDialog();
        } else if (this.bundle.activeCODE === 'model') {
          if (field === "INCLUDECURRENTYESNO" || field === "PRORATEUNBILLEDYESNO" || field === "LIMIT_UNPOSTED_AGECAPDAYS" || field === "LIMIT_UNPOSTED_INELIGIBLEPAYERSYESNO") {
            this.save();
          } else {
            this.openDialog();
          }
        }


        break;
      }
    }
  }

  /* ============================================================= */
  /*  DIALOG: CLASS LEVEL                                          */
  /* ============================================================= */
  openDialog(): void {
    this.popover_dialog.open();
  }

  closeDialog(): void {
    this.bundle.saved = true;
    this.popover_dialog.close();
  }


  /* ============================================================= */
  /*  SAVE WITH CHOICE                                             */
  /* ============================================================= */
  applyChoiceAndSave(choice: 'future' | 'all'): void {
    this.popover_dialog.close();

    this.bundle.FRONTENDARRAY.forEach(item => {
      item.cascaidToAllClasses = 'no';
      item.cascaidToAllpayers = 'no';

      if (this.bundle.activeCODE === 'classes' && choice === 'all') {
        item.cascaidToAllpayers = 'yes';
      } else if (this.bundle.activeCODE === 'model' && choice === 'all') {
        item.cascaidToAllClasses = 'yes';
        item.cascaidToAllpayers = 'yes';
      }

    });

    this.save();
  }

  /* ============================================================= */
  save(): void {
    this.bundle.saved = true;
    this.cd.detectChanges(); // Ensure the "Not Saved!" message updates
    this.llModelsService.NG_LL_model_AR_configEdit_edit(this.bundle.FRONTENDARRAY);
  }

  selectTab(code) {

    console.log("code: " + code)

    //var target = event.target || event.srcElement || event.currentTarget;

    this.bundle.activeCODE = code;
    this.bundle.saved = true;

    this.getData();
  }

  exportOnClick() {

    let label = this.bundle.fileLabel;

    //console.log(label)

    for (let k = 0; k < this.bundle.columns.length; k++) {

      this.bundle.columns[k].STUDYCOLUMNQUESTIONIDALPHA = this.bundle.columns[k].datafield;
      this.bundle.columns[k].STUDYCOLUMNLABEL = this.bundle.columns[k].text
      this.bundle.columns[k].SYSTEMORGANIZATIONFIELDCODE = this.bundle.columns[k].datafield
    }

    var rows = this.datagrid.getdisplayrows();

    this.LlUtilityService.saveCSV(rows, this.bundle.columns, label)

  };

}
